/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, title: NonNullable<unknown>, url: NonNullable<unknown> }} Email_Meeting_TextInputs */

const th_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} เชิญคุณเข้าร่วมการประชุม: ${i?.title}

เปิดที่นี่: ${i?.url}

คุณจะตอบรับหรือปฏิเสธก็ได้ ยังไม่มีอะไรเกิดขึ้นจนกว่าคุณจะตอบ`)
};

const en_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} invited you to a meeting: ${i?.title}.

Open it here: ${i?.url}

You can accept or decline — nothing happens until you do.`)
};

const ja_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} さんがミーティングに招待しました: ${i?.title}

こちらから開けます: ${i?.url}

参加するかどうかはあなた次第です。応答するまで何も起こりません。`)
};

const zh_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 邀请你参加一场会议：${i?.title}。

在此打开：${i?.url}

你可以接受或拒绝——在那之前不会发生任何事。`)
};

const es_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} te ha invitado a una reunión: ${i?.title}.

Ábrela aquí: ${i?.url}

Puedes aceptar o rechazar: no pasa nada hasta que lo hagas.`)
};

const pt_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} convidou você para uma reunião: ${i?.title}.

Abra aqui: ${i?.url}

Você pode aceitar ou recusar — nada acontece até você decidir.`)
};

const id_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} mengundang Anda ke sebuah pertemuan: ${i?.title}.

Buka di sini: ${i?.url}

Anda bisa menerima atau menolak — sampai saat itu tidak terjadi apa pun.`)
};

const fr_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} vous a invité à une réunion : ${i?.title}.

Ouvrez-la ici : ${i?.url}

Vous pouvez accepter ou refuser — rien ne se passe avant.`)
};

const tl_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inanyayahan ka ni ${i?.from} sa isang miting: ${i?.title}.

Buksan dito: ${i?.url}

Maaari kang tumanggap o tumanggi — hanggang doon ay walang mangyayari.`)
};

const vi_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} mời bạn vào một cuộc họp: ${i?.title}.

Mở tại đây: ${i?.url}

Bạn có thể nhận hoặc từ chối — trước đó thì chưa có gì xảy ra.`)
};

const ko_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}님이 회의에 초대했습니다: ${i?.title}.

여기서 열기: ${i?.url}

수락하거나 거절할 수 있으며, 그전까지는 아무 일도 일어나지 않습니다.`)
};

const de_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} hat dich zu einem Meeting eingeladen: ${i?.title}.

Hier öffnen: ${i?.url}

Du kannst zusagen oder absagen — bis dahin passiert nichts.`)
};

const ru_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} приглашает вас на встречу: ${i?.title}.

Открыть здесь: ${i?.url}

Вы можете согласиться или отказаться — до этого ничего не произойдёт.`)
};

const tr_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} sizi bir toplantıya davet etti: ${i?.title}.

Buradan açın: ${i?.url}

Kabul edebilir ya da reddedebilirsiniz — o ana kadar hiçbir şey olmaz.`)
};

const it_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ti ha invitato a una riunione: ${i?.title}.

Apri qui: ${i?.url}

Puoi accettare o rifiutare: fino ad allora non succede nulla.`)
};

const pl_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} zaprasza cię na spotkanie: ${i?.title}.

Otwórz tutaj: ${i?.url}

Możesz przyjąć albo odmówić — do tego czasu nic się nie dzieje.`)
};

const uk_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} запрошує вас на зустріч: ${i?.title}.

Відкрити тут: ${i?.url}

Ви можете погодитися або відмовитися — доти нічого не станеться.`)
};

const hi_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ने आपको एक बैठक के लिए आमंत्रित किया है: ${i?.title}।

यहाँ खोलें: ${i?.url}

आप स्वीकार या अस्वीकार कर सकते हैं — तब तक कुछ नहीं होगा।`)
};

const ar_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`دعاك ${i?.from} إلى اجتماع: ${i?.title}.

افتحه هنا: ${i?.url}

يمكنك القبول أو الرفض — ولا يحدث شيء قبل ذلك.`)
};

const ms_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} menjemput anda ke satu mesyuarat: ${i?.title}.

Buka di sini: ${i?.url}

Anda boleh terima atau tolak — sehingga itu tiada apa berlaku.`)
};

const bn_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} আপনাকে একটি সভায় আমন্ত্রণ জানিয়েছেন: ${i?.title}।

এখানে খুলুন: ${i?.url}

আপনি গ্রহণ বা প্রত্যাখ্যান করতে পারেন — তার আগে কিছুই ঘটবে না।`)
};

const zh_tw2_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 邀請你參加會議：${i?.title}。

在此開啟：${i?.url}

你可以接受或婉拒——在那之前不會有任何動作。`)
};

const zh_hk2_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 邀請你參加會議：${i?.title}。

在此開啟：${i?.url}

你可以接受或婉拒——在那之前不會有任何動作。`)
};

const ur_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} نے آپ کو ایک ملاقات میں مدعو کیا ہے: ${i?.title}۔

یہاں کھولیں: ${i?.url}

آپ قبول یا انکار کر سکتے ہیں — اس سے پہلے کچھ نہیں ہوگا۔`)
};

const fa_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} شما را به جلسه‌ای دعوت کرده است: ${i?.title}.

اینجا باز کنید: ${i?.url}

می‌توانید بپذیرید یا رد کنید — تا آن زمان چیزی رخ نمی‌دهد.`)
};

const sw_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} amekualika kwenye mkutano: ${i?.title}.

Fungua hapa: ${i?.url}

Unaweza kukubali au kukataa — hadi hapo hakuna kinachotokea.`)
};

const nl_email_meeting_text = /** @type {(inputs: Email_Meeting_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} heeft je uitgenodigd voor een gesprek: ${i?.title}.

Hier openen: ${i?.url}

Je kunt aannemen of afwijzen — tot dan gebeurt er niets.`)
};

/**
* | output |
* | --- |
* | "{from} invited you to a meeting: {title}. Open it here: {url} You can accept or decline — nothing happens until you do." |
*
* @param {Email_Meeting_TextInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_meeting_text = /** @type {((inputs: Email_Meeting_TextInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Meeting_TextInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_meeting_text(inputs)
	if (locale === "ja") return ja_email_meeting_text(inputs)
	if (locale === "zh") return zh_email_meeting_text(inputs)
	if (locale === "es") return es_email_meeting_text(inputs)
	if (locale === "pt") return pt_email_meeting_text(inputs)
	if (locale === "id") return id_email_meeting_text(inputs)
	if (locale === "fr") return fr_email_meeting_text(inputs)
	if (locale === "tl") return tl_email_meeting_text(inputs)
	if (locale === "vi") return vi_email_meeting_text(inputs)
	if (locale === "ko") return ko_email_meeting_text(inputs)
	if (locale === "de") return de_email_meeting_text(inputs)
	if (locale === "ru") return ru_email_meeting_text(inputs)
	if (locale === "tr") return tr_email_meeting_text(inputs)
	if (locale === "it") return it_email_meeting_text(inputs)
	if (locale === "pl") return pl_email_meeting_text(inputs)
	if (locale === "uk") return uk_email_meeting_text(inputs)
	if (locale === "hi") return hi_email_meeting_text(inputs)
	if (locale === "ar") return ar_email_meeting_text(inputs)
	if (locale === "ms") return ms_email_meeting_text(inputs)
	if (locale === "bn") return bn_email_meeting_text(inputs)
	if (locale === "zh-TW") return zh_tw2_email_meeting_text(inputs)
	if (locale === "zh-HK") return zh_hk2_email_meeting_text(inputs)
	if (locale === "ur") return ur_email_meeting_text(inputs)
	if (locale === "fa") return fa_email_meeting_text(inputs)
	if (locale === "sw") return sw_email_meeting_text(inputs)
	if (locale === "nl") return nl_email_meeting_text(inputs)
	return en_email_meeting_text(inputs)
});